import React from 'react';
/* eslint-disable */
export function ArrowDown(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.7188 2C11.2812 1.4375 10.875 0.5 10.125 0.5H1.84375C1.09375 0.5 0.6875 1.4375 1.25 2L5.375 6.25C5.53125 6.4375 5.75 6.5 6 6.5C6.21875 6.5 6.4375 6.4375 6.59375 6.25L10.7188 2Z"
        fill="currentColor"
      />
    </svg>
  );
}
